import React, { useEffect } from "react"
import ContentLayoutHeader from "../../../components/layouts/ContentLayoutHeader.layout"
import { useLocation, useNavigate } from "react-router-dom"
import ClientChip from "../../../components/molecules/ClientChip.molecule"
import { FORM_CLIENT_MODE } from "../../../consts/modules/clients.consts"
import { AppRoutes } from "../../../consts/appRoutes.consts"

const FormHeaderProject = ({ setMode }) => {
  const { state } = useLocation()
  const { client } = state || {}
  const { isCreate = false } = state || {}
  const navigate = useNavigate()
  useEffect(() => {
    if (!state) return navigate(AppRoutes.clientes.index)
  }, [state])
  useEffect(() => {
    setMode(isCreate ? FORM_CLIENT_MODE.CREATE : FORM_CLIENT_MODE.EDIT)
  }, [isCreate])
  const subtitleTemplate = () => {
    return (
      <div className="flex gap-2 align-items-center">
        <ClientChip clientCode={client?.code} />
        <span className="text-xl">{client?.name}</span>
      </div>
    )
  }
  return (
    <ContentLayoutHeader
      title={`${isCreate ? "Crear" : "Editar"} proyecto`}
      subtitle={subtitleTemplate()}
      goBack
    />
  )
}

export default FormHeaderProject
